import { useEffect, useRef } from 'react';

/**
 * Reusable "hooks-friendly" setInterval call
 * source: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * @param callback
 * @param delay
 * @param enabled whether to enable this interval
 */

const useInterval = (callback, delay = 10000, enabled = true) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    if (enabled) {
      const tick = () => {
        savedCallback.current();
      };
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay, enabled]);
};

export default useInterval;
